class FkCategoryCarousel extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('ul');
    this.controls = this.querySelector('.fk-subs__controls');
    this.buttons = [...this.querySelectorAll('[data-direction]')];
    this.abort = new AbortController();
    this.buttons.forEach(button => button.addEventListener('click', () => {
      this.list.scrollBy({left: Number(button.dataset.direction) * this.list.clientWidth * .8,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }, {signal: this.abort.signal}));
    this.list.addEventListener('scroll', this.update, {passive: true, signal: this.abort.signal});
    this.observer = new ResizeObserver(this.update);
    this.observer.observe(this.list);
    this.update();
  }
  update = () => {
    const max = this.list.scrollWidth - this.list.clientWidth;
    this.controls.hidden = max < 2;
    this.buttons[0].disabled = this.list.scrollLeft < 2;
    this.buttons[1].disabled = this.list.scrollLeft > max - 2;
  };
  disconnectedCallback() { this.abort.abort(); this.observer.disconnect(); }
}
if (!customElements.get('fk-category-carousel')) customElements.define('fk-category-carousel', FkCategoryCarousel);
